import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, post } from 'utils/api';
import { logError } from 'utils/log';
import { getGraphDateInterval } from 'utils/graphs/utils';
import {
  getEndpointConfig
} from 'modules/insights/sov/utils/consumer-insights/sov-consumer-insights';

const { CI } = API.END_POINTS;

const ANALYSIS_PROCESSING = 'sov-ci/ANALYSIS_PROCESSING';
const ANALYSIS_LOADED = 'sov-ci/ANALYSIS_LOADED';
const ANALYSIS_MARK_AS_RUN = 'sov-ci/ANALYSIS_MARK_AS_RUN';
const ANALYSIS_RESET = 'sov-ci/ANALYSIS_RESET';

import type { Action, Dispatch, ThunkAction } from 'types';
import type {
  SOVAnalysis,
  SOVAnalysisState,
  SOVReport
} from 'modules/insights/sov/types';

const initialState = {
  analysis: {},
  isLoading: false,
  analysisHasBeenRun: false
};

const setStatus = (status: boolean): Action => ({
  type: ANALYSIS_PROCESSING,

  payload: {
    status
  }
});

const analysisLoaded = (analysis: Array<SOVAnalysis>): Action => ({
  type: ANALYSIS_LOADED,

  payload: {
    analysis
  }
});

const markAnalysisAsRun = (): Action => ({
  type: ANALYSIS_MARK_AS_RUN,
  payload: {}
});

export const resetAnalysis = (): Action => ({
  type: ANALYSIS_RESET
});

export const runAnalysis = (report: SOVReport): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setStatus(true));
  dispatch(markAnalysisAsRun());

  const updatedData = {
    ...report,
    interval: getGraphDateInterval(report.startDate, report.endDate)
  };

  try {
    const url = CI.SOV.runAnalysis(updatedData.id, report.reportType);
    const configOptions = getEndpointConfig(report.id, updatedData);
    const response = await post(url, configOptions.config, configOptions.options);
    const analysis = response.data || {};

    dispatch(setStatus(false));

    return dispatch(analysisLoaded(analysis));
  } catch (error) {
    return logError(error);
  } finally {
    dispatch(setStatus(false));
  }
};

const handleProcessing = (state: SOVAnalysisState, { status }): SOVAnalysisState => ({
  ...state,
  isLoading: status
});

const handleLoaded = (state: SOVAnalysisState, { analysis }): SOVAnalysisState => ({
  ...state,
  analysis,
  isLoading: false
});

const handleMarkAsRun = (state: SOVAnalysisState): SOVAnalysisState => ({
  ...state,
  analysisHasBeenRun: true
});

export default createReducer<SOVAnalysisState, any>('sovAnalysisConsumerInsights', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [ANALYSIS_RESET]: () => initialState,
  [ANALYSIS_PROCESSING]: handleProcessing,
  [ANALYSIS_LOADED]: handleLoaded,
  [ANALYSIS_MARK_AS_RUN]: handleMarkAsRun
});
